/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			if (this.classList.contains('cart-recommendations')) {
				this.cart = true;
				this.parent = this.closest('.cart-recommendations--parent');
			}
		}
		fetchProducts() {
			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (this.parent) {
							if (this.cart) {
								this.parent.classList.add('cart-recommendations--full');
							} else {
								this.parent.classList.add('product-recommendations--full');
							}
						}
						this.querySelectorAll('.lazyload').forEach((image) => {
							lazySizes.loader.unveil(image);
						});
						
						// LOP - Disparar procesamiento de precios sin impuesto para productos cargados dinámicamente
						if (window.LOPPriceAdjustTimeout) {
							clearTimeout(window.LOPPriceAdjustTimeout);
						}
						window.LOPPriceAdjustTimeout = setTimeout(() => {
							const containers = this.querySelectorAll('.product-card .LOP-product-price-without-taxes');
							containers.forEach(container => {
								if (!container.classList.contains('lop-price-measured')) {
									// Disparar evento personalizado para que el script externo lo procese
									const event = new CustomEvent('lop-price-needs-adjustment', { detail: { container } });
									document.dispatchEvent(event);
								}
							});
							// También llamar directamente a la función si está disponible
							if (typeof window.processLOPPriceContainers === 'function') {
								window.processLOPPriceContainers();
							}
						}, 100);
					}

					this.classList.add('product-recommendations--loaded');

				})
				.catch(e => {
					console.error(e);
				});
		}
		connectedCallback() {
			this.fetchProducts();
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
